// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"river-2-portable-power-station_productcontent__bE0yk"};